// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gloom: PokeData = {
  "id": 44,
  "name": "gloom",
  "height": 8,
  "weight": 86,
  "base_experience": 138,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "acid",
    "absorb",
    "mega-drain",
    "growth",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "petal-dance",
    "toxic",
    "giga-drain",
    "sweet-scent",
    "moonlight",
    "natural-gift",
    "lucky-chant",
    "petal-blizzard",
    "grassy-terrain",
    "moonblast"
  ],
  "moves": [
    "acid",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "moonlight",
    "grassy-terrain",
    "moonblast",
    "mortal-gas",
    "toxic-spikes",
    "poison-jab",
    "sludge-bomb",
    "wood-hammer"
  ],
  "evolution_chain": {
    "id": 18,
    "item": null,
    "species": [
      {
        "name": "oddish",
        "order": 47,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gloom",
        "order": 48,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 43,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vileplume",
        "order": 49,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 44,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "bellossom",
        "order": 50,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 44,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.25,
    "speed": 40,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
